<div (click)="togglePanel()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <mat-icon class="side-nav-item-icon" [style.color]="color">
        account_circle
    </mat-icon>
    <span class="side-nav-item-text" [style.color]="color" *ngIf="showText">
        {{ sub() }}
    </span>
</div>
<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayOpen]="panelShown"
             (overlayOutsideClick)="togglePanel()">
    <mat-card class="profile-content">
        <mat-card-header>
            <mat-card-title>{{ name() }}</mat-card-title>
            <mat-card-subtitle *ngIf="!showText">{{ sub() }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-divider></mat-divider>
            <mat-nav-list>
                <a mat-list-item *ngIf="profileUrl()" [href]="profileUrl()" target="_blank">
                    <div class="profile-menu-item">
                        <mat-icon>person_outline</mat-icon>
                        <span>{{ 'Profile' | translate }}</span>
                    </div>
                </a>
                <a mat-list-item (click)="logout()" href="javascript:void(0)">
                    <div class="profile-menu-item">
                        <mat-icon>logout</mat-icon>
                        <span>{{ 'Logout' | translate }}</span>
                    </div>
                </a>
            </mat-nav-list>
            <div class="profile-menu" *ngIf="false">
                <a mat-button *ngIf="profileUrl()" [href]="profileUrl()" target="_blank">
                    <mat-icon>person_outline</mat-icon>
                    <span>{{ 'Profile' | translate }}</span>
                </a>
                <a mat-button (click)="logout()" href="javascript:void(0)">
                    <mat-icon>logout</mat-icon>
                    <span>{{ 'Logout' | translate }}</span>
                </a>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
